import { useDemo } from "../zustand/DemoZustand";
import { Abschnitt } from "../bausteine/Grundelemente";
import { Sprechblase } from "../bausteine/Symbole";
import { kanaluebersicht, nameVon } from "../hilfen/auswertung";
import { useChat } from "../zustand/ChatZustand";
import { kurzesDatum, uhrzeit } from "../hilfen/datum";

/*
  Die Kanäle der Fraktion.

  Früher stand hier ein Kanal je Tagesordnungspunkt — neun je Sitzung, bei
  zehn Sitzungen im Jahr neunzig im Jahr, von denen die meisten tot waren.
  Jetzt gibt es einen je Gremium: die Fraktion selbst und je einen Ausschuss.
  Das sind acht bis zwölf für eine ganze Wahlperiode, und in jedem steht ein
  Verlauf, der über die einzelne Sitzung hinausreicht.

  In allen Kanälen sitzt die ganze Fraktion. Wer im Bauausschuss nicht ist,
  liest trotzdem mit — die Fraktion stimmt im Rat geschlossen ab. Wem das zu
  laut ist, stellt den Kanal für sich stumm.
*/

export default function ChatsAnsicht({ oeffne }) {
  const { stammdaten, zustand, ich, aktionen } = useDemo();
  const chat = useChat();

  /*
    Die Beiträge kommen von Matrix, das Stummschalten und der Gelesen-Stand
    aus dem Browser. Beides zusammengeführt, damit die Auswertung eine reine
    Funktion bleiben kann.
  */
  const kanaele = kanaluebersicht(
    stammdaten,
    { ...zustand, nachrichten: chat.nachrichten },
    ich.id
  );

  return (
    <>
      <div className="detailkopf">
        <p className="detailkopf__vorspann">{stammdaten.gremien["g-fraktion"].name}</p>
        <h1 className="detailkopf__titel">Chats</h1>
      </div>

      <Abschnitt
        titel="Kanäle"
        hinweis="Ein Kanal je Gremium — er bleibt die ganze Wahlperiode bestehen. Nur innerhalb der Fraktion sichtbar."
      >
        <div className="kanaele">
          {kanaele.map(({ kanal, beitraege, letzter, ungelesen, stumm }) => (
            <div key={kanal.id} className={`kanalzeile ${stumm ? "kanalzeile--stumm" : ""}`}>
              <button
                className="kanalzeile__haupt"
                onClick={() => oeffne("kanal", { kanalId: kanal.id })}
              >
                <span className="kanalzeile__symbol" aria-hidden="true">
                  <Sprechblase groesse={20} />
                </span>

                <span className="kanalzeile__mitte">
                  <span className="kanalzeile__titel">
                    {kanal.name}
                    <span className="kanalzeile__art">{kanal.art}</span>
                  </span>
                  <span className="kanalzeile__vorschau">
                    {!chat.bereit && chat.stand !== "fehler"
                      ? "wird verbunden …"
                      : letzter
                        ? `${nameVon(stammdaten, letzter.verfasserId, ich.id)}: ${letzter.text}`
                        : "Noch keine Beiträge"}
                  </span>
                </span>

                <span className="kanalzeile__rechts">
                  <span className="klein leise">
                    {letzter ? `${kurzesDatum(letzter.zeit)}, ${uhrzeit(letzter.zeit)}` : "—"}
                  </span>
                  {/*
                    Angezeigt wird nur, was offen ist. „12 Beiträge, alle
                    gelesen“ ist eine Bestätigung ohne Neuigkeitswert — in
                    einer Liste, in der jede Zeile etwas ruft, findet niemand
                    mehr das Neue.

                    Auch ein stummer Kanal zeigt seine Zahl, nur zurückgenommen:
                    Stumm heißt leise, nicht versteckt.
                  */}
                  {ungelesen > 0 && (
                    <span className={`kanalzeile__neu ${stumm ? "kanalzeile__neu--stumm" : ""}`}>
                      {ungelesen} neu
                    </span>
                  )}
                </span>
              </button>

              <button
                className="kanalzeile__stumm"
                aria-pressed={stumm}
                aria-label={`${kanal.name} ${stumm ? "wieder laut stellen" : "stummschalten"}`}
                title={stumm ? "Wieder laut stellen" : "Stummschalten"}
                onClick={() => aktionen.setzeKanalStumm(kanal.id, !stumm)}
              >
                <Glocke durchgestrichen={stumm} />
                <span className="kanalzeile__stummwort">{stumm ? "Stumm" : "Laut"}</span>
              </button>
            </div>
          ))}
        </div>
      </Abschnitt>

      <p className="klein leise" style={{ marginTop: "var(--luft-4)" }}>
        Ein stummer Kanal meldet sich nicht von selbst, behält aber alle Beiträge und zeigt sie
        beim Öffnen vollständig. Wer dich namentlich anspricht, erreicht dich auch dort — das ist
        geplant und noch nicht gebaut.
      </p>
    </>
  );
}

/*
  Die Glocke gibt es noch nicht in den Symbolen, und sie wird nur hier
  gebraucht. Der Zustand hängt nicht am Symbol allein: Daneben steht immer
  das Wort „Laut“ oder „Stumm“, damit man ihn nicht am Bild erraten muss.
*/
function Glocke({ durchgestrichen }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.7 21a2 2 0 0 1-3.4 0" />
      {durchgestrichen && <line x1="3" y1="3" x2="21" y2="21" />}
    </svg>
  );
}
